<template>
  <div class="position-fixed top-0 w-100 z-index-1040 border-bottom bg-white">
    <div class="w-100 py-3 ga-container fluid">
      <div
        class="d-flex align-items-center justify-content-between w-100 flex-nowrap"
        style="min-width: 0">
        <!-- BACK BUTTON -->
        <div
          v-if="$route.name === 'BePaymentResult'"
          class="mr-3 cursor-pointer d-flex align-items-center justify-content-center back-button-premium"
          @click="backToBERoom">
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M15 18L9 12L15 6"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </div>

        <!-- LEFT SIDE: Logo + Hotel Info -->
        <div class="d-flex align-items-center flex-grow-1 overflow-hidden pr-4 cursor-pointer" style="min-width: 0" @click="backToHomepage()">

          <!-- Logo -->
          <img
            v-if="getMerchant.search_room_is_show_merchant_image"
            class="mr-3 hotel-information-image"
            :src="getMerchant.image_url"
            alt="Hotel Logo"
            style="flex-shrink: 0" />

          <!-- Hotel Info Container -->
          <div class="overflow-hidden" style="min-width: 0; width: 100%">
            <!-- Baris 1: Hotel Name + Stars -->
            <div
              class="d-flex align-items-start align-items-md-center justify-content-start mb-1"
              style="min-width: 0">
              <h4
                v-if="getMerchant.search_room_is_show_merchant_name"
                class="mb-0 text-truncate hotel-information-name"
                style="min-width: 0">
                {{ getMerchant.name }}
              </h4>
              <div
                class="ml-2 d-none d-sm-flex flex-shrink-0"
                v-if="getMerchant.search_room_is_show_merchant_star">
                <!-- Star Icons -->
                <svg
                  v-for="i in getMerchant.star"
                  class="mr-1"
                  height="16"
                  width="16"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <rect width="18" height="18" rx="2" fill="#F7941D" />
                  <path
                    d="M12.452 10.353C12.3009 10.4994 12.2315 10.7112 12.2659 10.9188L12.7845 13.7888C12.8283 14.0321 12.7256 14.2783 12.522 14.4188C12.3225 14.5647 12.0571 14.5822 11.8395 14.4655L9.25594 13.118C9.16611 13.0702 9.06636 13.0445 8.96428 13.0416H8.80619C8.75136 13.0498 8.69769 13.0673 8.64869 13.0941L6.06453 14.448C5.93678 14.5122 5.79211 14.5349 5.65036 14.5122C5.30503 14.4468 5.07461 14.1178 5.13119 13.7708L5.65036 10.9008C5.68478 10.6913 5.61536 10.4784 5.46428 10.3297L3.35786 8.28801C3.18169 8.11709 3.12044 7.86042 3.20094 7.62884C3.27911 7.39784 3.47861 7.22926 3.71953 7.19134L6.61869 6.77076C6.83919 6.74801 7.03286 6.61384 7.13203 6.41551L8.40953 3.79634C8.43986 3.73801 8.47894 3.68434 8.52619 3.63884L8.57869 3.59801C8.60611 3.56767 8.63761 3.54259 8.67261 3.52217L8.73619 3.49884L8.83536 3.45801H9.08094C9.30028 3.48076 9.49336 3.61201 9.59428 3.80801L10.8887 6.41551C10.982 6.60626 11.1634 6.73867 11.3729 6.77076L14.272 7.19134C14.517 7.22634 14.7218 7.39551 14.8029 7.62884C14.8793 7.86276 14.8134 8.11942 14.6337 8.28801L12.452 10.353Z"
                    fill="white" />
                </svg>
              </div>
            </div>

            <!-- Baris 2: Address -->
            <div class="d-flex align-items-center" style="min-width: 0">
              <svg
                class="mr-1 flex-shrink-0"
                width="14"
                height="14"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M2.625 7.73832C2.625 4.28842 5.50791 1.5 8.99508 1.5C12.4921 1.5 15.375 4.28842 15.375 7.73832C15.375 9.47677 14.7428 11.0907 13.7021 12.4587C12.5541 13.9676 11.1391 15.2823 9.54641 16.3143C9.18188 16.5528 8.85291 16.5708 8.45284 16.3143C6.85105 15.2823 5.43607 13.9676 4.29787 12.4587C3.25649 11.0907 2.625 9.47677 2.625 7.73832ZM6.89567 7.93256C6.89567 9.08828 7.83874 9.99725 8.99508 9.99725C10.1522 9.99725 11.1043 9.08828 11.1043 7.93256C11.1043 6.78585 10.1522 5.83262 8.99508 5.83262C7.83874 5.83262 6.89567 6.78585 6.89567 7.93256Z"
                  fill="#777" />
              </svg>
              <p
                class="mb-0 text-truncate flex-grow-1 hotel-information-address"
                style="min-width: 0">
                {{ getMerchant.address }}
              </p>
            </div>
          </div>
        </div>

        <!-- <router-link
          tag="a"
          class="d-flex align-items-center flex-grow-1 overflow-hidden pr-4"
          style="min-width: 0"
          :to="`/${getMerchant.code}/booking`">
        </router-link> -->

        <!-- RIGHT SIDE: Menu Icon -->
        <div class="flex-shrink-0">
          <div class="d-block d-md-none">
            <svg
              @click="toggleSidebarMenu"
              class="lh-1 cursor-pointer"
              width="28"
              height="15"
              viewBox="0 0 28 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_331_25)">
                <path
                  d="M1.09465 14.1298H26.6864C27.2606 14.1298 27.7254 13.665 27.7254 13.0771C27.7254 12.5029 27.2606 12.0518 26.6864 12.0518H1.09465C0.520474 12.0518 0.0693359 12.5029 0.0693359 13.0771C0.0693359 13.665 0.520474 14.1298 1.09465 14.1298Z"
                  fill="black"
                  fill-opacity="0.85" />
                <path
                  d="M1.09465 8.15563H26.6864C27.2606 8.15563 27.7254 7.7045 27.7254 7.13033C27.7254 6.54248 27.2606 6.07767 26.6864 6.07767H1.09465C0.520474 6.07767 0.0693359 6.54248 0.0693359 7.13033C0.0693359 7.7045 0.520474 8.15563 1.09465 8.15563Z"
                  fill="black"
                  fill-opacity="0.85" />
                <path
                  d="M1.09465 2.19516H26.6864C27.2606 2.19516 27.7254 1.74402 27.7254 1.16984C27.7254 0.595668 27.2606 0.130859 26.6864 0.130859H1.09465C0.520474 0.130859 0.0693359 0.595668 0.0693359 1.16984C0.0693359 1.74402 0.520474 2.19516 1.09465 2.19516Z"
                  fill="black"
                  fill-opacity="0.85" />
              </g>
              <defs>
                <clipPath id="clip0_331_25">
                  <rect
                    width="27.6561"
                    height="14.04"
                    fill="white"
                    transform="translate(0.0693359 0.0898438)" />
                </clipPath>
              </defs>
            </svg>
          </div>

          <div class="d-none d-md-flex align-items-center flex-shrink-0">
            <div
              @click="toggleShowLanguagePopup(true)"
              class="d-flex align-items-center cursor-pointer py-2 px-3 hovered-menu">
              <p class="mb-0 body-2-4 mr-2">{{ getCurrency.code }}</p>
              <svg
                height="7"
                viewBox="0 0 14 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M6.52769 8C6.7155 8 6.90325 7.92487 7.031 7.78212L12.8451 1.82535C12.9727 1.69765 13.0479 1.53239 13.0479 1.3446C13.0479 0.953987 12.7549 0.653519 12.3643 0.653519C12.1765 0.653519 12.0037 0.728637 11.876 0.848825L6.12205 6.7305H6.92581L1.17182 0.848825C1.05164 0.728637 0.878869 0.653519 0.683569 0.653519C0.292957 0.653519 0 0.953987 0 1.3446C0 1.53239 0.0751175 1.69765 0.202816 1.83286L6.01689 7.78212C6.15961 7.92487 6.33238 8 6.52769 8Z"
                  fill="black"
                  fill-opacity="0.85" />
              </svg>
            </div>

            <div class="ml-3" v-if="getMerchant.use_user_menu">
              <template v-if="$useCommunityAuth()">
                <userDropdownMenu v-if="isLoggedIn" />
                <button
                  v-else
                  @click="$loginWithCommunity()"
                  class="g-btn g-btn-md g-btn-primary rounded">
                  Register / Login
                </button>
              </template>
              <template v-else>
                <router-link
                  tag="div"
                  :to="`/${getMerchant.code}/account`"
                  class="d-flex align-items-center px-3 py-1 hovered-menu cursor-pointer"
                  v-if="isLoggedIn">
                  <p class="mb-0 body-2-4">{{ getCurrentUser.first_name }}</p>
                  <div
                    class="rounded-100 border-semi-grey overflow-hidden ml-2"
                    style="height: 30px; width: 30px">
                    <img
                      class="img-fit"
                      :src="getCurrentUser.avatar"
                      alt="User Avatar" />
                  </div>
                </router-link>
                <button
                  v-else
                  @click="goToLoginPage"
                  class="g-btn g-btn-md g-btn-primary rounded">
                  Register / Login
                </button>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <GeneralLanguageCurrency
      :showPopup="showLanguagePopup"
      @togglePopup="toggleShowLanguagePopup" />

    <popup-detail
      direction="right"
      :show="showSidebarMenu"
      :size="$useCommunityAuth() ? 90 : 75"
      @close="toggleSidebarMenu">
      <template v-slot:body>
        <template v-if="$useCommunityAuth() && isLoggedIn">
          <userMenuDetail @openCurrency="toggleShowLanguagePopup" />
        </template>
        <template v-else>
          <div class="p-4 bg-light-page text-center border-b-form">
            <img
              class="mb-3"
              :src="getMerchant.image_url"
              height="70"
              :alt="getMerchant.name" />
            <p class="mb-0 body-1-4">{{ getMerchant.name }}</p>
            <svg
              v-for="i in getMerchant.star"
              class="mr-1"
              height="18"
              width="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <rect width="18" height="18" rx="2" fill="#F7941D" />
              <path
                d="M12.452 10.353C12.3009 10.4994 12.2315 10.7112 12.2659 10.9188L12.7845 13.7888C12.8283 14.0321 12.7256 14.2783 12.522 14.4188C12.3225 14.5647 12.0571 14.5822 11.8395 14.4655L9.25594 13.118C9.16611 13.0702 9.06636 13.0445 8.96428 13.0416H8.80619C8.75136 13.0498 8.69769 13.0673 8.64869 13.0941L6.06453 14.448C5.93678 14.5122 5.79211 14.5349 5.65036 14.5122C5.30503 14.4468 5.07461 14.1178 5.13119 13.7708L5.65036 10.9008C5.68478 10.6913 5.61536 10.4784 5.46428 10.3297L3.35786 8.28801C3.18169 8.11709 3.12044 7.86042 3.20094 7.62884C3.27911 7.39784 3.47861 7.22926 3.71953 7.19134L6.61869 6.77076C6.83919 6.74801 7.03286 6.61384 7.13203 6.41551L8.40953 3.79634C8.43986 3.73801 8.47894 3.68434 8.52619 3.63884L8.57869 3.59801C8.60611 3.56767 8.63761 3.54259 8.67261 3.52217L8.73619 3.49884L8.83536 3.45801H9.08094C9.30028 3.48076 9.49336 3.61201 9.59428 3.80801L10.8887 6.41551C10.982 6.60626 11.1634 6.73867 11.3729 6.77076L14.272 7.19134C14.517 7.22634 14.7218 7.39551 14.8029 7.62884C14.8793 7.86276 14.8134 8.11942 14.6337 8.28801L12.452 10.353Z"
                fill="white" />
            </svg>
          </div>
          <div class="px-4 py-3">
            <template v-if="getMerchant.use_user_menu">
              <template v-if="$useCommunityAuth()">
                <a
                  v-if="isLoggedIn"
                  :href="$getCommunityUrl('/account/profile')"
                  target="_blank"
                  class="mb-0 body-2-4 mr-2 w-100 py-3"
                  >Profile</a>
                <div
                  v-else
                  @click="$loginWithCommunity()"
                  class="mb-0 body-2-4 mr-2 w-100 py-3"
                  >Login / Register</div>
              </template>
              <template v-else>
                <router-link
                  v-if="isLoggedIn"
                  :to="`/${getMerchant.code}/account`"
                  tag="a"
                  class="mb-0 body-2-4 mr-2 w-100 py-3">
                  Profile
                </router-link>
                <div
                  v-else
                  @click="openAuthFromSidebar()"
                  class="mb-0 body-2-4 mr-2 w-100 py-3 cursor-pointer">
                  Login / Register
                </div>
              </template>
            </template>
            <p
              @click="toggleShowLanguagePopup(true)"
              class="mb-0 body-2-4 mr-2 w-100 py-3 cursor-pointer">
              Currency
            </p>
          </div>
        </template>
      </template>
    </popup-detail>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import GeneralLanguageCurrency from '../general/GeneralLanguageCurrency.vue';
import userDropdownMenu from './be/desktop/userDropdownMenu.vue';
import userMenuDetail from './userMenuDetail.vue';

export default {
  props: ['page'],
  components: {
    GeneralLanguageCurrency,
    userDropdownMenu,
    userMenuDetail
  },
  data() {
    return {
      showLanguagePopup: false,
      showSidebarMenu: false,
    };
  },
  computed: {
    ...mapGetters([
      'getMerchant',
      'getCurrency',
      'isLoggedIn',
      'getCurrentUser',
    ]),
    merchantStarText() {
      const { merchant_category_name, star } = this.getMerchant;
      const categoryName = this.$capitalize(merchant_category_name, true);
      const starText = this.$pluralWord(star, 'Star');
      return `${star} ${starText} ${categoryName}`;
    },
  },
  methods: {
    ...mapMutations(['setActiveRoute']),
    toggleShowLanguagePopup(show = false) {
      this.showLanguagePopup = show;
    },
    toggleSidebarMenu() {
      this.showSidebarMenu = !this.showSidebarMenu;
    },
    goToLoginPage(){
      this.$openAuthModal({ view: 'login' })
    },
    /* the drawer owns the body scroll lock, so let it unmount before the popup opens */
    openAuthFromSidebar(){
      this.showSidebarMenu = false;
      this.$nextTick(() => this.$openAuthModal({ view: 'login' }));
    },
    backToBERoom() {
      this.$router.push({ name: 'BERoom' });
    },
    backToHomepage(){
      const isBookingPage = this.$route.name === 'BERoom';

      if(isBookingPage){
        const useCustomHomepageUrl = this.getMerchant.search_room_custom_homepage_url ;
        if(this.$isNotEmptyV2(useCustomHomepageUrl)){
          this.$openLink(useCustomHomepageUrl)
          return;
        }
      }


      this.$router.push(`/${this.getMerchant.code}/booking`);
    },
  },
};
</script>
<style>
.hovered-menu {
  border: 1px solid transparent;
  border-radius: 4px;
}
.hovered-menu:hover {
  background-color: #f5f6f8;
  border: 1px solid #ccc;
}
.back-button-premium {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1.5px solid #eaeaea;
  background: #ffffff;
  color: #333333;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  flex-shrink: 0;
  box-shadow: 0 1px 2px rgba(0,0,0,0.05);
}
.back-button-premium:hover {
  background-color: #f9fafb;
  border-color: #d1d5db;
  color: #000;
  transform: translateX(-1px);
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}
.back-button-premium:active {
  transform: scale(0.95) translateX(-1px);
}
.hotel-information-image {
  max-width: 40px;
}
.hotel-information-name {
  font-size: 18px;
  font-family: Nunito-ExtraBold;
  color: #222222;
  letter-spacing: 0.25px;
}
.hotel-information-address {
  font-size: 12px !important;
  font-family: Nunito-SemiBold;
  color: #777;
  letter-spacing: 0.25px;
}
.flex-fill-auto {
  flex: 1;
  min-width: 0;
}
@media screen and (min-width: 768px) {
  .hotel-information-name {
    font-size: 20px;
  }
  .hotel-information-address {
    font-size: 14px !important;
  }
}
@media screen and (min-width: 992px) {
  .hotel-information-name {
    font-size: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/hotel/HotelTopNavbar.vue